import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orgInfoFn, depListFn } from '@/api/org/dep';
import { sysInfoFn as _sysInfoFn } from '@/api/org/per';
export default {
  name: 'searchPopup',
  props: ['pageName'],
  data: function data() {
    return {
      visible: false,
      popover: false,
      treeList: [],
      name: '',
      treeProps: {
        label: 'department_name',
        isLeaf: 'is_sub_department'
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      hireDate: '',
      leaveDate: '',
      treeCheckList: [],
      dataForm: {
        department_id: [],
        settlement_type: [],
        formal: [],
        state: [],
        hire_start_date: '',
        hire_end_date: '',
        leave_start_date: '',
        leave_end_date: ''
      },
      settlement_type: [],
      formal: [],
      state: [],
      tempDataForm: {},
      sysInfoData: {},
      isSubmit: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    window.addEventListener('beforeunload', function (e) {
      return _this.beforeunloadHandler(e);
    });
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.visible = true;
      this.sysInfoFn();
      this.getOrgInfo();
      this.defaultCheckedKeys = this.treeCheckList;
      if (sessionStorage.getItem('searchResult')) {
        var searchValue = JSON.parse(sessionStorage.getItem('searchResult'));
        this.defaultCheckedKeys = searchValue.default_checked_keys.map(function (i) {
          return i.department_id;
        });
        //  console.log(JSON.stringify(sessionStorage.getItem('searchResult')))
        Object.keys(this.dataForm).map(function (item) {
          if (item === 'department_id') return;
          _this2.dataForm[item] = searchValue[item];
        });
      }
    },
    // 获取选项
    sysInfoFn: function sysInfoFn() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) _this3.sysInfoData = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleNodeClick: function handleNodeClick() {
      // 选中节点
      this.treeCheckList = this.$refs.tree.getCheckedNodes();
    },
    departmentClear: function departmentClear() {
      // 删除节点
      this.treeCheckList.splice(0, 1);
      this.$refs.tree.setCheckedNodes(this.treeCheckList);
    },
    beforeunloadHandler: function beforeunloadHandler() {
      sessionStorage.removeItem('searchResult');
    },
    settlementTypeChange: function settlementTypeChange() {
      if (this.dataForm.settlement_type.length > 1) {
        this.dataForm.settlement_type.shift();
      }
    },
    getOrgInfo: function getOrgInfo() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, obj;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return orgInfoFn();
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this4.isShowTips = !res.data.supervisor_id;
                obj = {
                  department_name: res.data.department_name,
                  department_id: Number(res.data.id),
                  supervisor_id: res.data.supervisor_id,
                  supervisor_name: res.data.supervisor_name
                };
                _this4.defaultExpandedKeys.push(Number(res.data.id));
                _this4.curNode = obj;
                _this4.treeList = [_objectSpread({
                  is_sub_department: false
                }, obj)];
                _this4.tableData = [_objectSpread(_objectSpread({}, obj), {}, {
                  is_sub_department: true
                })];
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    hireDateChange: function hireDateChange(v) {
      if (v) {
        var _v = _slicedToArray(v, 2),
          start = _v[0],
          end = _v[1];
        this.dataForm.hire_start_date = start;
        this.dataForm.hire_end_date = end;
      } else {
        this.dataForm.hire_start_date = '';
        this.dataForm.hire_end_date = '';
      }
    },
    leaveDateChange: function leaveDateChange(v) {
      if (v) {
        var _v2 = _slicedToArray(v, 2),
          start = _v2[0],
          end = _v2[1];
        this.dataForm.leave_start_date = start;
        this.dataForm.leave_end_date = end;
      } else {
        this.dataForm.leave_start_date = '';
        this.dataForm.leave_end_date = '';
      }
    },
    loadNode: function loadNode(node, resolve) {
      var _this5 = this;
      if (node.data.department_id) {
        this.hasDepListFn = true;
        depListFn({
          department_id: node.data.department_id
        }).then(function (res) {
          _this5.hasDepListFn = false;
          _this5.tableData = res.data;
          resolve(res.data.map(function (v) {
            return {
              department_name: v.department_name,
              department_id: Number(v.department_id),
              is_sub_department: !v.is_sub_department,
              staff_count: v.staff_count
            };
          }));
        });
      }
    },
    handleProcessData: function handleProcessData(data) {
      this.dataForm.settlement_type = this.dataForm.settlement_type.toString();
      this.dataForm.formal = this.dataForm.formal.toString();
      this.dataForm.state = this.dataForm.state.toString();
      return data;
    },
    doReset: function doReset() {
      this.isSubmit = false;
      this.beforeunloadHandler();
      this.$refs.tree.setCheckedKeys([]);
      this.dataForm.leave_end_date = '';
      this.dataForm.leave_start_date = '';
      this.dataForm.hire_end_date = '';
      this.dataForm.hire_start_date = '';
      this.dataForm.formal = [];
      this.dataForm.state = [];
      this.dataForm.settlement_type = [];
      this.dataForm.department_id = [];
      this.hireDate = '';
      this.leaveDate = '';
    },
    closeDrawer: function closeDrawer() {
      if (!this.isSubmit) this.doReset();
    },
    doSubmit: function doSubmit() {
      var _this6 = this;
      this.isSubmit = true;
      // if (this.dataForm.settlement_type.length === 0) {
      //   this.$message.error('结算方式不能为空')
      //   return
      // }
      var searchResult = {
        default_checked_keys: this.$refs.tree.getCheckedNodes(),
        settlement_type: this.dataForm.settlement_type,
        formal: this.dataForm.formal,
        state: this.dataForm.state,
        hire_start_date: this.dataForm.hire_start_date,
        hire_end_date: this.dataForm.hire_end_date,
        leave_start_date: this.dataForm.leave_start_date,
        leave_end_date: this.dataForm.leave_end_date
      };
      sessionStorage.removeItem('searchResult');
      sessionStorage.setItem('searchResult', JSON.stringify(searchResult));
      this.dataForm.department_id = [];
      this.$refs.tree.getCheckedNodes().map(function (item) {
        _this6.dataForm.department_id.push({
          id: item.department_id,
          department_name: item.department_name,
          is_sub_department: item.is_sub_department
        });
      });
      this.tempDataForm = this.dataForm;
      this.handleProcessData();
      this.visible = false;
      this.$emit('submit', this.dataForm);
    },
    destroyed: function destroyed() {
      var _this7 = this;
      window.removeEventListener('beforeunload', function (e) {
        return _this7.beforeunloadHandler(e);
      });
    }
  }
};